import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faThumbsUp,
  faCalendarAlt,
  faStar,
  faTh,
} from "@fortawesome/pro-regular-svg-icons";

library.add(faThumbsUp, faCalendarAlt, faStar, faTh);

export { faThumbsUp, faCalendarAlt, faStar, faTh };
